'use strict';

require("core-js/modules/es.function.bind");

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;